// trouble importing this file in test environment

export const rateConStatusesLookup = {
  accepted: {
    title: 'Accepted',
    query: '&q[status_in][]=accepted',
  },
  cancelled: {
    title: 'Cancelled',
    query: '&q[status_in][]=cancelled',
  },
  new: {
    title: 'New',
    query: '&q[status_in][]=delivered',
  },
  pending: {
    title: 'Pending',
    query: '&q[status_in][]=pending',
  },
  rejected: {
    title: 'Rejected',
    query: '&q[status_in][]=rejected',
  },
  updated: {
    title: 'Updated',
    query: '&q[status_in][]=updated',
  },
  viewed: {
    title: 'Viewed',
    query: '&q[status_in][]=viewed',
  },
};

export const rateConFilterLookup = {
  search: {
    title: 'Search',
    query:
      '&q[carrier_legal_name_or_subject_or_carrier_identifiers_value_i_cont]=',
  },
  status: {
    title: 'Status',
    query: '&q[status_in][]=',
  },
  creatorId: {
    title: 'Creator ID',
    query: '&q[creator_id_eq]=',
  },
  subject: {
    title: 'Subject',
    query: '&q[subject_cont]=',
  },
  carrierName: {
    title: 'Carrier Name',
    query: '&q[carrier_legal_name_search_cont]=',
  },
  mc: {
    title: 'Carrier MC',
    query:
      '&q[carrier_identifiers_is_type_eq]=MC&q[carrier_identifiers_value_non_padded_eq]=',
  },
  dot: {
    title: 'Carrier DOT',
    query:
      '&q[carrier_identifiers_is_type_eq]=DOT&q[carrier_identifiers_value_non_padded_eq]=',
  },
  windowStart: {
    title: 'Window start range date',
    query: '&q[updated_at_gteq]=',
  },
  windowEnd: {
    title: 'Window end range date',
    query: '&q[updated_at_lteq]=',
  },
};

export const rateConSortLookup = {
  createdAsc: {
    id: 1,
    title: 'Ascending by Created At',
    query: 'created_at+asc',
  },
  createdDesc: {
    id: 2,
    title: 'Descending by Created At',
    query: 'created_at+desc',
  },
  updatedAsc: {
    id: 3,
    title: 'Ascending by Updated At',
    query: 'updated_at+asc',
  },
  updatedDesc: {
    id: 4,
    title: 'Descending by Updated At',
    query: 'updated_at+desc',
  },
};

export const defaultRateConQueryTabLookup = {
  all: { carrierIdType: 'mc', page: 1, sort: 'createdDesc', tab: 'all' },
  my: { carrierIdType: 'mc', page: 1, sort: 'createdDesc', tab: 'my' },
};
